module.exports = __webpack_public_path__ + "1efe896fc63e5d6b412442b05531f4c2.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-panel-320.webp
// module id = 471
// module chunks = 0